import React, { Component } from "react";
import { Modal, Button, textarea } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from '../actions/index';
import moment from 'moment';
import * as constants from '../const';

class NotesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noteText:'',
      emptyNote:false,
      submitted:false
    }
  }

  // rendering all notes for an emplyee for a particular day
  renderNotes(){
    let notes = '';
    if(this.props.notesObj && this.props.notesObj.notes && this.props.notesObj.notes != ''){
      notes = this.props.notesObj.notes;
      let notesArray = notes.split('~');
      notesArray.pop();
      return (
        <div className="content-border">
          <ul className="notesList">
            {
              notesArray.map(function (note, index) {
                      return (<li key={index}><span>{note}</span></li>);
                  })
            }
          </ul>
        </div>
    )
    } else {
      notes = '';
      return (
        <div className="content-border">
        </div>
      );
    }    
  }
  
  // reset notes
  resetNotes(){
    this.setState({
      noteText:'',
      emptyNote:false,
      submitted:false
    })
  }
  // submitting a note
  submitNote(){
    this.setState({
      submitted:true
    })
    if(this.state.noteText.trim() == ''){
      this.setState({
        emptyNote:true
      })
    } else {
      let workdayId = this.props.notesObj.workdayId,
          workdayDate = this.props.notesObj.workdayDate,
          prevNotes = this.props.notesObj.notes,
          finalNotes = '';
      if(prevNotes && prevNotes != ''){
        finalNotes = prevNotes + this.state.noteText + "~";
      } else {
        finalNotes = this.state.noteText  + "~";
      }    
      let notesObj = {
        workdayId:workdayId,
        finalNotes:finalNotes,
        workdayDate:workdayDate
      }
      let self = this;
      this.props.submitNote(notesObj, function(success){
         if(success){
            self.props.hideNotesModal();  
            self.resetNotes();            
         }        
      })
    }
  }

  // saving fields values on state
  handleChange(e) { // changing of username/passowrd
    const { name, value } = e.target;
    this.setState({ [name]: value });
  } 

  // render notes component
  renderNotesModal() {
    if (this.props.showModal) {
      var workdayDate = this.props.notesObj.workdayDate,
          workdayDate = moment(workdayDate, 'YYYYMMDD'),
          workdayDate = workdayDate.format('MM/DD/YYYY');
      return (
        <Modal className="notesModalContainer"
          show={
            this.props.showModal && this.props.modalName == "notes_Modal"
          }
          onHide={() => this.props.hideNotesModal()}
        >
          <Modal.Header>
            <button type="button" className="close" onClick={() => this.props.hideNotesModal()}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            <div className="hos-modal-header">
              <span> Notes for {workdayDate}</span>
            </div>
          </Modal.Header>
          
          <Modal.Body className="notesModalBody">
          <h5><strong>Notes:</strong></h5>
            {
              this.renderNotes()
            }
          </Modal.Body>
          <Modal.Footer>
              <div className="col-sm-9 notesFooter">
                <textarea className="form-control" placeholder="write note" 
                    name="noteText" value={this.state.noteText} onChange={this.handleChange.bind(this)} />
                <span className={"text-danger " + (!this.state.submitted && !this.state.emptyNote ? 'hidden' : '')} title="Please enter note">*</span>
              </div>
              <button className="col-sm-3 btn btn-primary btnPrimaryColor" onClick={() => this.submitNote()}>
                Save Notes</button>
          </Modal.Footer>
        </Modal>
      );
    } else {
      <div />;
    }
  }

  render() {
    return this.renderNotesModal();
  }
}

function mapStateToProps(state) {
  // coming from store
  return {
    showModal: state.notes.notesObj.showNotesModal,
    modalName: state.notes.notesObj.modalName,
    notes:state.notes.notes,
    notesObj:state.notes.notesObj
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNotes:actions.fetchNotes,
      hideNotesModal: actions.hideNotesModal,
      submitNote:actions.submitNoteAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(NotesModal);